import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div`
    background-color: ${colors.brandDark};
`;

export const Inner = styled.div`
    padding: 50px 0;
    text-align: center;

    ${breakpoints.large} {
        padding: 75px 0;
    }
`;

export const Title = styled.h1`
    color: ${colors.brandMid};
    font-size: 18px;
    margin-bottom: 16px;
    font-weight: 800;

    ${breakpoints.large} {
        font-size: 28px;
    }
`;

export const Subtitle = styled.h3`
    color: ${colors.white};
    font-size: 25px;
    margin-bottom: 24px;

    ${breakpoints.large} {
        margin-bottom: 32px;
        font-size: 48px;
    }
`;
